/* eslint-disable no-underscore-dangle */
import '@/utils/rem';
import { createApp } from 'vue';
import ArcoVue from '@arco-design/web-vue';
import ArcoVueIcon from '@arco-design/web-vue/es/icon';
import globalComponents from '@/components';
import store from '@/store';
import i18n from '@/locale';
import * as Sentry from '@sentry/vue';
import { initAnalytics } from '@/utils/analytics';
import router from './router';
import directive from './directive';
import App from './App.vue';
import '@/assets/style/global.less';
import '@/api/interceptor';

// eslint-disable-next-line import/no-unresolved
import 'virtual:svg-icons-register';

const app = createApp(App);
app.use(i18n);
app.use(ArcoVue, {});
app.use(ArcoVueIcon);
app.use(store);
app.use(router);
app.use(globalComponents);
app.use(directive);

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN, // Sentry 项目的 DSN 地址
  environment: import.meta.env.VITE_SENTRY_ENV || 'development', // 环境标识（正式/测试/开发）
  integrations: [
    Sentry.browserTracingIntegration(), // 浏览器链路追踪集成
    Sentry.replayIntegration(), // 会话重放集成
  ],
  // 性能监控配置
  tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0, // 性能采样率：生产环境采样 10%，开发/测试环境全量采样
  // 控制哪些 URL 允许分布式追踪
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/knit\.parametrix\.cn/,
    '192.168.16.38',
    '10.225.0.38',
  ],
  // 会话重放采样率配置
  replaysSessionSampleRate: import.meta.env.MODE === 'production' ? 0.01 : 0.1, // 全量会话采样率：生产环境 1%，开发/测试环境 10%
  replaysOnErrorSampleRate: 1.0, // 发生错误时的会话采样率：所有报错会话都会被完整记录
});

initAnalytics();

app.mount('#app');
